import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/guards/auth-guard';

//Components
import { PublicLayoutComponent } from './layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './layout/private-layout/private-layout.component';

import { UserManagementComponent } from './user-management/user-management.component';
import { CrudComponent } from './components/crud/crud.component';
import { UserProfileComponent } from './user/user-profile/user-profile.component';
import { UpdatePasswordComponent } from './user/update-password/update-password.component';
import { AddCustomerComponent } from './components/customers/add-customer/add-customer.component';
import { EditCustomerComponent } from './components/customers/edit-customer/edit-customer.component';
import { EditDynamicCustomerComponent } from './components/customers/edit-dynamic-customer/edit-dynamic-customer.component';
import { UploadCustomersComponent } from './components/customers/upload-customers/upload-customers.component';
import { CustomersLayoutComponent } from './components/customers/customers-layout/customers-layout.component';
import { CustomersComponent } from './components/customers/customers-list/customers.component';
import { UpdateProfileComponent } from './user/update-profile/update-profile.component';
import { UsersLayoutComponent } from './user/users-layout/users-layout.component';
import { BuildingsLayoutComponent } from './components/buildings/buildings-layout/buildings-layout.component';
import { BuildingsComponent } from './components/buildings/buildings-list/buildings/buildings.component';
import { DynamicBuildingsComponent } from './components/dynamic-buildings/dynamic-buildings.component';
import { DynamicCustomersComponent } from './components/customers/dynamic-customers/dynamic-customers.component';
import { EditDynamicBuildingComponent } from './components/buildings/edit-dynamic-building/edit-dynamic-building.component';
import { EditBuildingsComponent } from './components/buildings/edit-buildings/edit-buildings/edit-buildings.component';
import { AddBuildingComponent } from './components/buildings/add-building/add-building.component';
import { UploadComponent } from './components/upload/upload.component';
import { PolesLayoutComponent } from './components/poles/poles-layout/poles-layout.component';
import { PolesComponent } from './components/poles/poles-list/poles/poles.component';
import { EditPolesComponent } from './components/poles/edit-poles/edit-poles.component';
import { AddPoleComponent } from './components/poles/add-pole/add-pole.component';
import { TransformersLayoutComponent } from './components/transformers/transformers-layout/transformers-layout.component';
import { TransformersComponent } from './components/transformers/transformers-list/transformers.component';
import { AddTransformerComponent } from './components/transformers/add-transformer/add-transformer.component';
import { EditTransformerComponent } from './components/transformers/edit-transformer/edit-transformer.component';
import { AuditLogComponent } from './components/audit-log/audit-log.component';
import { AuditTrailComponent } from './components/audit-trail/audit-trail.component';
import { MetersLayoutComponent } from './components/meters/meters-layout/meters-layout.component';
import { MetersListComponent } from './components/meters/meters-list/meters-list.component';
import { SurveyLayoutComponent } from './components/survey/survey-layout/survey-layout.component';
import { SurveyComponent } from './components/survey/survey/survey.component';
import { SurveyDetailsComponent } from './components/survey/survey-details/survey-details.component';
import { InstallationLayoutComponent } from './components/installations/installation-layout/installation-layout.component';
import { InstallationsListComponent } from './components/installations/installations-list/installations-list.component';
import { InstallationDetailsComponent } from './components/installations/installation-details/installation-details.component';
import { DtMeterInstallationDetailsComponent } from './components/installations/dt-meter-installation-details/dt-meter-installation-details.component';
import { DtMeterInstallationInvoiceDetailsComponent } from './components/installations/dt-meter-installation-invoice-details/dt-meter-installation-invoice-details.component';
import { EditOnboardCustomerComponent } from './components/customers/edit-onboard-customer/edit-onboard-customer.component';
import { RoleManagementComponent } from './role-management/role-management.component';
import { PermissionsEnum } from './models/role.model';
import { BpsAdminDashboardComponent } from './components/bps_admin/bps-admin-dashboard/bps-admin-dashboard.component';
import { BpsAuthGuard } from './services/guards/bps-guard';
import { UtilityListComponent } from './components/bps_admin/utility-management/utility-list/utility-list.component';
import { UtilityLayoutComponent } from './components/bps_admin/utility-management/utility-layout/utility-layout.component';
import { AddUtilityComponent } from './components/bps_admin/utility-management/add-utility/add-utility.component';
import { UtilityDetailsComponent } from './components/bps_admin/utility-management/utility-details/utility-details.component';
import { UtilityAssetAndCustomerEntitiesComponent } from './components/bps_admin/utility-asset-and-customer-entities/utility-asset-and-customer-entities.component';
import { BpsAdminJobHistoryComponent } from './components/bps_admin/bps-admin-job-history/bps-admin-job-history.component';
import { DashboardConfiguration } from './models/utility.model';
import { EditMeterComponent } from './components/meters/edit-meter/edit-meter.component';
import { LandingComponent } from './components/kyc/landing/landing.component';
import { LoginKycComponent } from './components/kyc/login-kyc/login-kyc.component';
import { DashboardKycComponent } from './components/kyc/dashboard-kyc/dashboard-kyc.component';
import { RegisterComponent } from './components/kyc/register/register.component';
import { ResetPasswordComponent } from './components/kyc/reset-password/reset-password.component';
import { SetNewPasswordComponent } from './components/kyc/set-new-password/set-new-password.component';
import { ReportsComponent } from './components/reports/reports.component';
import { KycAuthGuard } from './services/guards/kyc-guard';
import { WorkOrdersComponent } from './components/work-orders/work-orders.component';
import { SiteVerificationDetailsComponent } from './components/work-orders/site-verification/site-verification-details/site-verification-details.component';
import { KycDetailsComponent } from './components/customers/kyc-details/kyc-details.component';
import { NewWorkOrderComponent } from './components/work-orders/maintenance/new-work-order/new-work-order.component';
import { WorkOrdersLayoutComponent } from './components/work-orders/work-orders-layout/work-orders-layout.component';
import { WorkOrderMenuItem } from './models/workOrderMenuItem.model';
import { WorkOrderDetailsComponent } from './components/work-orders/maintenance/work-order-details/work-order-details.component';
import { MeterStockInventory } from './components/meterManagement/meter-stock-inventory/meter-stock-inventory.component';
import { NewServiceComponent } from './components/new-service/new-service.component';
import { NewServiceDetailsComponent } from './components/new-service/new-service-details/new-service-details.component';
import { NewServiceLayoutComponent } from './components/new-service/new-service-layout/new-service-layout.component';
import { ServiceConnectionDetailsComponent } from './components/work-orders/service-connection/service-connection-details/service-connection-details.component';
import { MeterStockDecommissionedListComponent } from './components/meterManagement/meter-stock-decommissioned/meter-stock-decommissioned-list/meter-stock-decommissioned-list.component';
import { MeterStockUtilizationComponent } from './components/meterManagement/meter-stock-utilization/meter-stock-utilization.component';
import { MeterStockDecommissionedDetailsComponent } from './components/meterManagement/meter-stock-decommissioned/meter-stock-decommissioned-details/meter-stock-decommissioned-details.component';
import { MeterStockDecommissionedLayoutComponent } from './components/meterManagement/meter-stock-decommissioned/meter-stock-decommissioned-layout/meter-stock-decommissioned-layout.component';
import { AddBillingAccountComponent } from './components/customers/add-billing-account/add-billing-account.component';
import { ReadingsComponent } from './components/readings/readings.component';
import { ReadingsLayoutComponent } from './components/readings/readings-layout/readings-layout.component';
import { ReadingDetailsComponent } from './components/readings/meter-readings/reading-details/reading-details.component';
import { NetworkAssetsComponent } from './components/network-assets/network-assets.component';
import { AdvancedMapComponent } from './components/advanced-map/advanced-map.component';
import { RmusComponent } from './components/rmu/rmus/rmus.component';
import { EditRmuComponent } from './components/rmu/edit-rmu/edit-rmu.component';
import { RmuLayoutComponent } from './components/rmu/rmu-layout/rmu-layout.component';
import { AiImageUploadComponent } from './components/ai-image-upload/ai-image-upload.component';
import { MeterValidationLayoutComponent } from './components/meter-validation/meter-validation-layout/meter-validation-layout.component';
import { MeterValidationListPageComponent } from './components/meter-validation/meter-validation-list-page/meter-validation-list-page.component';
import { MeterValidationDetailsComponent } from './components/meter-validation/meter-validation-details/meter-validation-details.component';
import { MvPolesComponent } from './components/mv-poles/mv-poles.component';
import { MvPolesLayoutComponent } from './components/mv-poles/mv-poles-layout/mv-poles-layout.component';
import { EditMvPolesComponent } from './components/mv-poles/edit-mv-poles/edit-mv-poles.component';
import { GeneratePaymentComponent } from './components/survey/generate-payment/generate-payment.component';

// lib imports
import {
  AiJobMonitoringComponent,
  AiOverviewComponent,
  AiSegmentationListComponent,
  BatchImageImportComponent,
  DynamicSubstationListComponent,
  EditInjectionSubstationComponent,
  NetworkModelCustomizationComponent,
  AddEquipmentAndConnectivityComponent,
  DataModelCustomizationComponent,
  NetworkEntityClassesComponent,
  DashboardComponent as V3DashboardComponent,
  LoginComponent,
  HelpComponent,
  ForgotPasswordComponent,
  EditCimSubstationComponent,
  CimSubstationListComponent,
  OtpVerificationComponent
} from 'shared-lib';
import { PaymentHistoryDetailsComponent } from './components/payment-history/payment-history-details/payment-history-details.component';
import { PaymentHistoryListComponent } from './components/payment-history/payment-history-list/payment-history-list.component';
import { PaymentHistoryLayoutComponent } from './components/payment-history/payment-history-layout/payment-history-layout.component';
import { SettlementListComponent } from './components/payment-history/settlement-list/settlement-list.component';
import { SettlementDetailsComponent } from './components/payment-history/settlement-details/settlement-details.component';
import { ServiceRequestTrackerDetailsComponent } from './components/new-service/service-request-tracker-details/service-request-tracker-details.component';

const routes: Routes = [
  {
    path: 'customers-app',
    canActivate: [KycAuthGuard],
    loadChildren: () =>
      import('./_modules/customers/customers.module').then(
        (m) => m.CustomersModule,
      ),
  },

  // Public layout
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: '', component: LoginComponent, pathMatch: 'full' },
      { path: 'login', component: LoginComponent, pathMatch: 'full' },
      { path: 'generate-payment/:utilityGuid/:surveyGuid', component: GeneratePaymentComponent, pathMatch: 'full' },
      // { path: 'login/:guid', component: LoginComponent, pathMatch: 'full' },
      { path: 'help', component: HelpComponent, pathMatch: 'full' },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        pathMatch: 'full',
      },
      {
        path: 'new-connection/:utility',
        component: LandingComponent,
        pathMatch: 'full',
      },
      {
        path: 'new-connection/:utility/register',
        component: RegisterComponent,
        pathMatch: 'full',
      },
      {
        path: 'new-connection/:utility/login',
        component: LoginKycComponent,
        pathMatch: 'full',
      },
      {
        path: 'new-connection/:utility/dashboard',
        component: DashboardKycComponent,
        pathMatch: 'full',
      },
      {
        path: 'new-connection/:utility/reset-password-request',
        component: ResetPasswordComponent,
        pathMatch: 'full',
      },
      {
        path: 'new-connection/:utility/reset-password',
        component: SetNewPasswordComponent,
        pathMatch: 'full',
      },
      {
        path: 'verify-otp',
        component: OtpVerificationComponent,
        pathMatch: 'full',
      },
    ],
  },
  // Private layout
  {
    path: '',
    component: PrivateLayoutComponent,
    children: [
      {
        path: 'profile',
        component: UsersLayoutComponent,
        canActivate: [AuthGuard],
        data: { headerTitle: 'HEADER_TITLE.CUSTOMER' },
        children: [
          {
            path: '',
            component: UserProfileComponent,
            data: { headerTitle: 'HEADER_TITLE.CUSTOMER' },
          },
          {
            path: 'update-password',
            component: UpdatePasswordComponent,
            data: {
              headerTitle: 'HEADER_TITLE.CUSTOMER',
              headerBreadcrumb: 'HEADER_BREADCRUMB.UPDATE_PASSWORD',
            },
          },
          {
            path: 'update',
            component: UpdateProfileComponent,
            data: {
              headerTitle: 'HEADER_TITLE.CUSTOMER',
              headerBreadcrumb: 'HEADER_BREADCRUMB.UPDATE_PROFILE',
            },
          },
        ],
      },
      {
        path: 'dashboard',
        component: V3DashboardComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
        data: { headerTitle: 'HEADER_TITLE.ANALYTICS' },
      },
      {
        path: 'role-management',
        component: RoleManagementComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
        data: {
          headerTitle: 'HEADER_TITLE.ROLE_MANAGEMENT',
          permission: [PermissionsEnum.RoleManagement_View],
        },
      },
      {
        path: 'user-management',
        component: UserManagementComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
        data: {
          headerTitle: 'HEADER_TITLE.USER_MANAGEMENT',
          permission: [PermissionsEnum.UserManagement_View],
        },
      },
      {
        path: 'crud/:id',
        component: CrudComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
        data: {
          headerTitle: 'HEADER_TITLE.CRUD_SETTINGS',
          permission: [
            PermissionsEnum.Ts_View,
            PermissionsEnum.F11_View,
            PermissionsEnum.F33_View,
            PermissionsEnum.Ss_View,
            PermissionsEnum.Transformers_ViewCrud,
            PermissionsEnum.Area_View,
            PermissionsEnum.Region_View,
            PermissionsEnum.Tariff_View,
            PermissionsEnum.MeterType_View,
            PermissionsEnum.AssetRating_View,
            PermissionsEnum.AssetStatus_View,
            PermissionsEnum.Customer_ViewCrud,
            PermissionsEnum.DtMeterType_View,
            PermissionsEnum.MeterPrice_View,
            PermissionsEnum.BillingAccounts_View,
            PermissionsEnum.MeterAssignment_View,
          ],
        },
      },
      {
        path: 'work-orders',
        component: WorkOrdersLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          headerTitle: 'HEADER_TITLE.WORK_ORDERS',
        },
        children: [
          {
            path: 'tab/:id',
            component: WorkOrdersComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.WORK_ORDERS',
              permission: [PermissionsEnum.SiteVerification],
            },
          },
          {
            path: 'new-work-order',
            component: NewWorkOrderComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.WORK_ORDER',
              headerBreadcrumb: 'HEADER_BREADCRUMB.NEW_WORK_ORDER',
              goBackTo: `/work-orders/tab/${WorkOrderMenuItem.Maintenance}`,
            },
          },
          {
            path: 'work-order-details/:id',
            component: WorkOrderDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: `/work-orders/tab/${WorkOrderMenuItem.Maintenance}`,
              headerTitle: 'HEADER_TITLE.WORK_ORDER',
              headerBreadcrumb: 'HEADER_BREADCRUMB.WORK_ORDER_DETAILS',
            },
          },
        ],
      },
      {
        path: 'map',
        component: AdvancedMapComponent,
        canActivate: [AuthGuard],
        data: {
          headerTitle: 'HEADER_TITLE.MAP',
          permission: [PermissionsEnum.Map_View],
        },
      },
      {
        path: 'readings',
        component: ReadingsLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          headerTitle: 'HEADER_TITLE.READINGS',
          permission: [PermissionsEnum.Readings_View],
        },
        children: [
          {
            path: 'tab/:id',
            component: ReadingsComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.READINGS',
              configuration: DashboardConfiguration.Readings,
              // permission: [PermissionsEnum.MeterReading],
            },
          },
          {
            path: 'reading-details/:id',
            component: ReadingDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: 'rd',
              headerTitle: 'HEADER_TITLE.METER_READING',
              headerBreadcrumb: 'HEADER_BREADCRUMB.METER_READING_DETAILS',
            },
          },
        ],
      },
      {
        path: 'meter-validation',
        component: MeterValidationLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          headerTitle: 'HEADER_TITLE.METER_VALIDATION',
          permission: [PermissionsEnum.Meter_Validation_View],
        },
        children: [
          {
            path: '',
            component: MeterValidationListPageComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.METER_VALIDATION',
              configuration: DashboardConfiguration.MeterValidation,
              // permission: [PermissionsEnum.MeterReading],
            },
          },
          {
            path: 'details/:id',
            component: MeterValidationDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/meter-validation',
              headerTitle: 'HEADER_TITLE.METER_VALIDATION',
              headerBreadcrumb: 'HEADER_BREADCRUMB.METER_VALIDATION_DETAILS',
              configuration: DashboardConfiguration.MeterValidation,
              // configuration: DashboardConfiguration.MeterManagement,
            },
          },
        ],
      },
      {
        path: 'reports/:id',
        component: ReportsComponent,
        canActivate: [AuthGuard],
        data: {
          headerTitle: 'HEADER_TITLE.REPORTS'
        },
      },
      {
        path: 'new-service/:id',
        component: NewServiceLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          headerTitle: 'HEADER_TITLE.NEW_SERVICE'
        },
        children: [
          {
            path: '',
            component: NewServiceComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.NEW_SERVICE',
              headerBreadcrumb: 'HEADER_BREADCRUMB.NEW_SERVICE',
            },
          },
          {
            path: 'new-service-details/:detailsId',
            component: NewServiceDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/new-service/1',
              headerTitle: 'HEADER_TITLE.SERVICE_REQUEST',
              headerBreadcrumb: 'HEADER_BREADCRUMB.SERVICE_REQUEST_DETAILS',
            },
          },
          {
            path: 'verification-details/:detailsId',
            component: SiteVerificationDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: `/new-service/2`,
              headerTitle: 'HEADER_TITLE.SITE_VERIFICATION',
              headerBreadcrumb: 'HEADER_BREADCRUMB.SITE_VERIFICATION_DETAILS',
            },
          },
          {
            path: 'service-connection-details/:detailsId',
            component: ServiceConnectionDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: `/new-service/3`,
              headerTitle: 'HEADER_TITLE.SERVICE_CONNECTION_CHARGES',
              headerBreadcrumb: 'HEADER_BREADCRUMB.SERVICE_CONN_CHARGE_DETAILS',
            },
          },
          {
            path: 'onboarded-customer-details/:detailsId',
            component: NewServiceDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/new-service/4',
              headerTitle: 'HEADER_TITLE.ONBOARDED_CUSTOMERS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.ONBOARDED_CUSTOMER_DETAILS',
            },
          },
          {
            path: 'service-request-tracker-details/:detailsId',
            component: ServiceRequestTrackerDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/new-service/5',
              headerTitle: 'HEADER_TITLE.SERVICE_REQUEST_TRACKER',
              headerBreadcrumb: 'HEADER_BREADCRUMB.SERVICE_REQUEST_TRACKER_DETAILS',
            },
          },
        ],
      },
      {
        path: 'customers',
        component: CustomersLayoutComponent,
        data: { headerTitle: 'HEADER_TITLE.CUSTOMERS' },
        children: [
          {
            path: '',
            component: DynamicCustomersComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.CUSTOMERS',
              permission: [PermissionsEnum.Customer_View],
              configuration: DashboardConfiguration.Buildings,
            },
          },
          {
            path: 'add/:isNewConnection/:utilityId',
            component: AddCustomerComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.CUSTOMERS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.NEW_CUSTOMER',
              permission: [PermissionsEnum.Customer_CreateEdit],
              usePadding: true,
            },
          },
          {
            path: 'add-billing-account/:utilityId',
            component: AddBillingAccountComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/crud/15',
              headerTitle: 'HEADER_TITLE.BILLING_ACCOUNT',
              headerBreadcrumb: 'HEADER_BREADCRUMB.NEW_BILLING_ACCOUNT',
              permission: [PermissionsEnum.BillingAccounts_CreateEdit],
            },
          },
          {
            path: 'edit-billing-account/:id/:utilityId',
            component: AddBillingAccountComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/crud/15',
              headerTitle: 'HEADER_TITLE.BILLING_ACCOUNT',
              headerBreadcrumb: 'HEADER_BREADCRUMB.EDIT_BILLING_ACCOUNT',
              permission: [PermissionsEnum.BillingAccounts_CreateEdit],
            },
          },
          {
            path: 'crud-edit/:id/:utilityId',
            component: AddCustomerComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/crud/9',
              headerTitle: 'HEADER_TITLE.CUSTOMERS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.CUSTOMER_DETAILS',
              permission: [
                PermissionsEnum.Customer_CreateEditCrud,
                PermissionsEnum.Customer_ViewCrud,
              ],
            },
          },
          {
            path: 'report-view/:id',
            component: EditCustomerComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/reports/0',
              headerTitle: 'HEADER_TITLE.CUSTOMERS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.CUSTOMER_DETAILS',
            },
          },
          {
            path: 'edit/:guid',
            component: EditDynamicCustomerComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/customers',
              headerTitle: 'HEADER_TITLE.CUSTOMERS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.CUSTOMER_DETAILS',
              permission: [PermissionsEnum.Customer_View],
              configuration: DashboardConfiguration.Buildings,
            },
          },
          {
            path: 'data-quality/:id',
            component: EditCustomerComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/reports/1',
              headerTitle: 'HEADER_TITLE.CUSTOMERS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.CUSTOMER_DETAILS',
            },
          },
          {
            path: 'data-quality/direct/:id',
            component: EditOnboardCustomerComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/reports/1',
              headerTitle: 'HEADER_TITLE.CUSTOMERS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.CUSTOMER_DETAILS',
            },
          },
          {
            path: 'edit-onboard/:id',
            component: EditOnboardCustomerComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/customers',
              headerTitle: 'HEADER_TITLE.CUSTOMERS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.CUSTOMER_DETAILS',
              permission: [PermissionsEnum.Customer_View],
              configuration: DashboardConfiguration.Buildings,
            },
          },
          {
            path: 'kyc-details/:id',
            component: KycDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/customers',
              headerTitle: 'HEADER_TITLE.CUSTOMERS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.CUSTOMER_DETAILS',
              permission: [PermissionsEnum.Customer_View],
              configuration: DashboardConfiguration.Buildings,
            },
          },
          {
            path: 'upload',
            component: UploadCustomersComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.CUSTOMERS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.UPLOAD_CUSTOMERS',
              permission: [
                PermissionsEnum.Customer_CreateEdit,
                PermissionsEnum.Customer_CreateEditCrud,
              ],
              configuration: DashboardConfiguration.Buildings,
            },
          },
        ],
      },
      {
        path: 'customers-dynamic/edit/:guid',
        component: EditDynamicCustomerComponent,
        canActivate: [AuthGuard],
        data: {
          goBackTo: '/customers-dynamic',
          headerTitle: 'HEADER_TITLE.CUSTOMERS',
          headerBreadcrumb: 'HEADER_BREADCRUMB.CUSTOMER_DETAILS',
          permission: [PermissionsEnum.Customer_View],
          configuration: DashboardConfiguration.Buildings,
        },
      },
      {
        path: 'buildings-dynamic',
        component: DynamicBuildingsComponent,
        canActivate: [AuthGuard],
        data: {
          headerTitle: 'HEADER_TITLE.BUILDINGS',
          permission: [PermissionsEnum.Building_View],
          configuration: DashboardConfiguration.Buildings,
        },
        
      },
      {
        path: 'buildings-dynamic/edit/:guid',
        component: EditDynamicBuildingComponent,
        canActivate: [AuthGuard],
        data: {
          goBackTo: '/buildings-dynamic',
          headerTitle: 'HEADER_TITLE.BUILDING',
          headerBreadcrumb: 'HEADER_BREADCRUMB.BUILDING_DETAILS',
          permission: [PermissionsEnum.Building_View],
          configuration: DashboardConfiguration.Buildings,
        },
      },
      {
        path: 'buildings',
        component: BuildingsLayoutComponent,
        data: { headerTitle: 'HEADER_TITLE.BUILDINGS' },
        children: [
          {
            path: '',
            component: DynamicBuildingsComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.BUILDINGS',
              permission: [PermissionsEnum.Building_View],
              configuration: DashboardConfiguration.Buildings,
            },
          },
          {
            path: 'edit/:guid',
            component: EditDynamicBuildingComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/buildings',
              headerTitle: 'HEADER_TITLE.BUILDING',
              headerBreadcrumb: 'HEADER_BREADCRUMB.BUILDING_DETAILS',
              permission: [PermissionsEnum.Building_View],
              configuration: DashboardConfiguration.Buildings,
            },
          },
          {
            path: 'data-quality/:id',
            component: EditBuildingsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/reports/1',
              headerTitle: 'HEADER_TITLE.BUILDING',
              headerBreadcrumb: 'HEADER_BREADCRUMB.BUILDING_DETAILS',
              permission: [PermissionsEnum.Building_View],
              configuration: DashboardConfiguration.Buildings,
            },
          },
          {
            path: 'duplicate/:id',
            component: EditBuildingsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/reports/3',
              headerTitle: 'HEADER_TITLE.BUILDING',
              headerBreadcrumb: 'HEADER_BREADCRUMB.BUILDING_DETAILS',
              permission: [PermissionsEnum.Building_View],
              configuration: DashboardConfiguration.Buildings,
            },
          },
          {
            path: 'add',
            component: AddBuildingComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.BUILDING',
              headerBreadcrumb: 'HEADER_BREADCRUMB.NEW_BUILDING',
              permission: [PermissionsEnum.Building_CreateEdit],
              configuration: DashboardConfiguration.Buildings,
            },
          },
        ],
      },
      {
        path: 'meter-stock-inventory',
        component: MeterStockInventory,
        canActivate: [AuthGuard],
        data: {
          headerTitle: 'HEADER_TITLE.METER_STOCK_INVENTORY',
          permission: [
            PermissionsEnum.CustomerMeterStockInventory_View,
            PermissionsEnum.AssetMeterStockInventory_View,
            PermissionsEnum.CtvtMeterStockInventory_View
          ],
          configuration: [
            DashboardConfiguration.MeterCustomers,
            DashboardConfiguration.MeterAssets,
            DashboardConfiguration.MeterCtvt,
          ],
        },
      },
      {
        path: 'meter-stock-decommissioned',
        component: MeterStockDecommissionedLayoutComponent,
        data: {
          headerTitle: 'HEADER_TITLE.DECOMMISSIONED_METER_STOCK',
        },
        children: [
          {
            path: '',
            component: MeterStockDecommissionedListComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.DECOMMISSIONED_METER_STOCK',
              permission: [PermissionsEnum.CustomerDecommissionedMeterStock_View],
              configuration: DashboardConfiguration.MeterCustomers,
            },
          },
          {
            path: 'details/:id',
            component: MeterStockDecommissionedDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/meter-stock-decommissioned',
              headerTitle: 'HEADER_TITLE.DECOMMISSIONED_METER_STOCK',
              headerBreadcrumb:
                'HEADER_BREADCRUMB.DECOMMISSIONED_METER_DETAILS',
              permission: [PermissionsEnum.CustomerDecommissionedMeterStock_View],
              configuration: DashboardConfiguration.MeterCustomers,
            },
          },
        ],
      },
      {
        path: 'meter-stock-utilization',
        component: MeterStockUtilizationComponent,
        canActivate: [AuthGuard],
        data: {
          headerTitle: 'HEADER_TITLE.METER_STOCK_UTILIZATION',
          permission: [
            PermissionsEnum.CustomerMeterStockInventory_ViewUtilizationStock,
            PermissionsEnum.AssetMeterStockInventory_ViewUtilizationStock,
            PermissionsEnum.CtvtMeterStockInventory_ViewUtilizationStock
          ],
          configuration: [
            DashboardConfiguration.MeterCustomers,
            DashboardConfiguration.MeterAssets,
            DashboardConfiguration.MeterCtvt,
          ],
        },
      },
      {
        path: 'upload/:type/:isNewConnection/:utilityId',
        component: UploadComponent,
        canActivate: [AuthGuard],
        data: {
          headerTitle: 'HEADER_TITLE.UPLOAD',
          headerBreadcrumb: 'HEADER_BREADCRUMB.UPLOAD',
          permission: [
            PermissionsEnum.Building_CreateEdit,
            PermissionsEnum.Customer_CreateEdit,
            PermissionsEnum.Pole_CreateEdit,
            PermissionsEnum.Transformers_CreateEdit,
            PermissionsEnum.Meters_CreateEdit,
            PermissionsEnum.Survey_CreateEdit,
          ],
        },
      },
      {
        path: 'upload/:type/:utilityId',
        component: UploadComponent,
        canActivate: [AuthGuard],
        data: {
          headerTitle: 'HEADER_TITLE.UPLOAD',
          headerBreadcrumb: 'HEADER_BREADCRUMB.UPLOAD',
          permission: [
            PermissionsEnum.Building_CreateEdit,
            PermissionsEnum.Customer_CreateEdit,
            PermissionsEnum.Pole_CreateEdit,
            PermissionsEnum.Transformers_CreateEdit,
            PermissionsEnum.Meters_CreateEdit,
            PermissionsEnum.Survey_CreateEdit,
            PermissionsEnum.Customer_CreateEditCrud,
            PermissionsEnum.NewService_CreateEdit,
            PermissionsEnum.DtMeterInstallation_VendorAssignment,
            PermissionsEnum.DtMeterInstallation_CreateEdit
          ],
        },
      },
      {
        path: 'superHiddenUpload',
        component: AiImageUploadComponent,
        canActivate: [AuthGuard],
        data: {
          headerTitle: 'HEADER_TITLE.UPLOAD',
          headerBreadcrumb: 'HEADER_BREADCRUMB.UPLOAD',
        },
      },
      {
        path: 'injection-substation',
        component: DynamicSubstationListComponent,
        pathMatch: 'full',
        data: {
          headerTitle: 'HEADER_TITLE.INJECTION_SUBSTATION',
          configuration: DashboardConfiguration.InjectionSubstation,
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'asset-list/substations/edit/:guid',
        canActivate: [AuthGuard],
        component: EditInjectionSubstationComponent,
        data: {
          configuration: DashboardConfiguration.InjectionSubstation,
        },
      },
      {
        path: 'distribution-substations',
        component: TransformersLayoutComponent,
        data: { headerTitle: 'HEADER_TITLE.TRANSFORMERS' },
        children: [
          {
            path: '',
            component: TransformersComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.TRANSFORMERS',
              permission: [PermissionsEnum.Transformers_View],
              configuration: DashboardConfiguration.DTs,
            },
          },
          {
            path: ':id/:parentType/:parentName',
            component: TransformersComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.TRANSFORMERS',
              permission: [PermissionsEnum.Transformers_View],
              configuration: DashboardConfiguration.DTs,
            },
          },
          {
            path: 'add',
            component: AddTransformerComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.TRANSFORMER',
              headerBreadcrumb: 'HEADER_BREADCRUMB.NEW_TRANSFORMER',
              permission: [PermissionsEnum.Transformers_CreateEdit],
              configuration: DashboardConfiguration.DTs,
            },
          },
          {
            path: 'edit/:id',
            component: EditTransformerComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/distribution-substations',
              headerTitle: 'HEADER_TITLE.TRANSFORMER',
              headerBreadcrumb: 'HEADER_BREADCRUMB.TRANSFORMER_DETAILS',
              permission: [PermissionsEnum.Transformers_View],
              configuration: DashboardConfiguration.DTs,
            },
          },
          {
            path: 'data-quality/:id',
            component: EditTransformerComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/reports/1',
              headerTitle: 'HEADER_TITLE.TRANSFORMER',
              headerBreadcrumb: 'HEADER_BREADCRUMB.TRANSFORMER_DETAILS',
            },
          },
          {
            path: 'duplicate/:id',
            component: EditTransformerComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/reports/3',
              headerTitle: 'HEADER_TITLE.TRANSFORMER',
              headerBreadcrumb: 'HEADER_BREADCRUMB.TRANSFORMER_DETAILS',
              permission: [PermissionsEnum.Transformers_View],
              configuration: DashboardConfiguration.DTs,
            },
          },
        ],
      },
      {
        path: 'poles',
        component: PolesLayoutComponent,
        data: { headerTitle: 'HEADER_TITLE.LT_POLE' },
        children: [
          {
            path: '',
            component: PolesComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.LT_POLES',
              permission: [PermissionsEnum.Pole_View],
              configuration: DashboardConfiguration.Poles,
            },
          },
          {
            path: 'edit/:id',
            component: EditPolesComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/poles',
              headerTitle: 'HEADER_TITLE.POLE',
              headerBreadcrumb: 'HEADER_BREADCRUMB.POLE_DETAILS',
              permission: [PermissionsEnum.Pole_View],
              configuration: DashboardConfiguration.Poles,
            },
          },
          {
            path: 'data-quality/:id',
            component: EditPolesComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/reports/1',
              headerTitle: 'HEADER_TITLE.POLE',
              headerBreadcrumb: 'HEADER_BREADCRUMB.POLE_DETAILS',
              permission: [PermissionsEnum.Pole_View],
              configuration: DashboardConfiguration.Poles,
            },
          },
          {
            path: 'add',
            component: AddPoleComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.POLE',
              headerBreadcrumb: 'HEADER_BREADCRUMB.NEW_POLE',
              permission: [PermissionsEnum.Pole_CreateEdit],
              configuration: DashboardConfiguration.Poles,
            },
          },
        ],
      },
      {
        path: 'mv-poles',
        component: MvPolesLayoutComponent,
        data: { headerTitle: 'HEADER_TITLE.MV_POLES' },
        children: [
          {
            path: '',
            component: MvPolesComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.MV_POLES',
              permission: [PermissionsEnum.MVPole_View],
              configuration: DashboardConfiguration.MVPoles,
            },
          },
          {
            path: 'edit/:id',
            component: EditMvPolesComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/mv-poles',
              headerTitle: 'HEADER_TITLE.MV_POLE',
              headerBreadcrumb: 'HEADER_BREADCRUMB.MV_POLE_DETAILS',
              permission: [PermissionsEnum.MVPole_View],
              configuration: DashboardConfiguration.MVPoles,
            },
          },
        ],
      },
      {
        path: 'meters',
        component: MetersLayoutComponent,
        data: { headerTitle: 'HEADER_TITLE.METERS' },
        children: [
          {
            path: '',
            component: MetersListComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.METERS',
              permission: [PermissionsEnum.Meters_View],
              configuration: DashboardConfiguration.Meters,
            },
          },
          {
            path: 'edit/:customerId',
            component: EditMeterComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/meters',
              headerTitle: 'HEADER_TITLE.METERS',
              permission: [PermissionsEnum.Meters_View],
              headerBreadcrumb: 'HEADER_BREADCRUMB.METER_DETAILS',
              configuration: DashboardConfiguration.Meters,
            },
          },

          
        ],
      },
      {
        path: 'cim-substations/:id',
        canActivate: [AuthGuard],
        component: CimSubstationListComponent,
        data: {
          permission: [PermissionsEnum.NetworkStructure_View],
        }
      },
      {
        path: 'cim-substations/:id/edit/:guid',
        canActivate: [AuthGuard],
        component: EditCimSubstationComponent,
        data: {
          permission: [PermissionsEnum.NetworkStructure_View],
        }
      },
      {
        path: 'surveys',
        component: SurveyLayoutComponent,
        data: { headerTitle: 'HEADER_TITLE.SURVEYS' },
        children: [
          {
            path: '',
            component: SurveyComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.SURVEYS',
              permission: [PermissionsEnum.Survey_View],
              configuration: DashboardConfiguration.Survey,
            },
          },
          {
            path: 'details/:id',
            component: SurveyDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/surveys',
              headerTitle: 'HEADER_TITLE.SURVEY',
              headerBreadcrumb: 'HEADER_BREADCRUMB.SURVEY_DETAILS',
              permission: [PermissionsEnum.Survey_View],
              configuration: DashboardConfiguration.Survey,
            },
          },
        ],
      },
      {
        path: 'installations',
        component: InstallationLayoutComponent,
        data: { headerTitle: 'HEADER_TITLE.INSTALLATIONS' },
        children: [
          {
            path: '',
            component: InstallationsListComponent,
            canActivate: [AuthGuard],
            data: {
              permission: [
                PermissionsEnum.Installation_View,
                PermissionsEnum.DtMeterInstallation_View
              ],
              headerTitle: 'HEADER_TITLE.INSTALLATIONS',
              configuration: [
                DashboardConfiguration.Installation,
                DashboardConfiguration.DtMeterInstallation,
              ],
            },
          },
          {
            path: 'details/:id',
            component: InstallationDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/installations',
              permission: [PermissionsEnum.Installation_View],
              headerTitle: 'HEADER_TITLE.INSTALLATIONS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.INSTALLATION_DETAILS',
              configuration: DashboardConfiguration.Installation,
            },
          },
          {
            path: 'invoice/details/:id',
            component: DtMeterInstallationInvoiceDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/installations',
              permission: [
                PermissionsEnum.DtMeterInstallation_ViewInvoiceApproval,
                PermissionsEnum.DtMeterInstallation_ViewActiveRepayment,
                PermissionsEnum.DtMeterInstallation_ViewCompletedPayment,
              ],
              headerTitle: 'HEADER_TITLE.INSTALLATIONS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.INVOICE_DETAILS',
              configuration: DashboardConfiguration.MeterApprovalAndRepayment,
            },
          },
          {
            path: 'dt/details/:id',
            component: DtMeterInstallationDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/installations',
              permission: [PermissionsEnum.DtMeterInstallation_View],
              headerTitle: 'HEADER_TITLE.INSTALLATIONS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.INSTALLATION_DETAILS',
              configuration: DashboardConfiguration.DtMeterInstallation,
            },
          },
          {
            path: 'dt/awaiting-approval/:id',
            component: DtMeterInstallationDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/installations',
              permission: [PermissionsEnum.DtMeterInstallation_ViewMeterApproval],
              headerTitle: 'HEADER_TITLE.INSTALLATIONS',
              headerBreadcrumb: 'HEADER_BREADCRUMB.INSTALLATION_DETAILS',
              configuration: DashboardConfiguration.MeterApprovalAndRepayment,
            },
          },
        ],
      },
      {
        path: 'payment-history',
        component: PaymentHistoryLayoutComponent,
        data: { headerTitle: 'HEADER_TITLE.PAYMENT_HISTORY' },
        children: [
          {
            path: '',
            component: PaymentHistoryListComponent,
            canActivate: [AuthGuard],
            data: {
              permission: [PermissionsEnum.PaymentHistory_View],
              headerTitle: 'HEADER_TITLE.PAYMENT_HISTORY',
              configuration: DashboardConfiguration.PaymentHistory,
            },
          },
          {
            path: 'details/:id',
            component: PaymentHistoryDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/payment-history',
              permission: [PermissionsEnum.PaymentHistory_View],
              headerTitle: 'HEADER_TITLE.PAYMENT_HISTORY',
              headerBreadcrumb: 'HEADER_BREADCRUMB.PAYMENT_HISTORY_DETAILS',
              configuration: DashboardConfiguration.PaymentHistory,
            },
          },
          {
            path: 'settlements',
            component: SettlementListComponent,
            canActivate: [AuthGuard],
            pathMatch: 'full',
            data: {
              permission: [PermissionsEnum.Settlement_View],
              headerTitle: 'HEADER_TITLE.PAYMENT_HISTORY',
              configuration: DashboardConfiguration.Settlement,
            },
          },
          {
            path: 'settlements/details/:id',
            component: SettlementDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/payment-history/settlements',
              permission: [PermissionsEnum.Settlement_View],
              headerTitle: 'HEADER_TITLE.PAYMENT_HISTORY',
              headerBreadcrumb: 'HEADER_BREADCRUMB.SETTLEMENT_DETAILS',
              configuration: DashboardConfiguration.Settlement,
            },
          },
        ],
      },
      {
        path: 'network-assets',
        component: NetworkAssetsComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
        data: { headerTitle: 'HEADER_TITLE.NETWORK_ASSETS' },
      },
      {
        path: 'rmus',
        component: RmuLayoutComponent,
        data: { headerTitle: 'HEADER_TITLE.RMU' },
        children: [
          {
            path: '',
            component: RmusComponent,
            canActivate: [AuthGuard],
            data: {
              headerTitle: 'HEADER_TITLE.RMU',
            },
          },
          {
            path: 'edit/:id',
            component: EditRmuComponent,
            canActivate: [AuthGuard],
            data: {
              goBackTo: '/rmus',
              headerTitle: 'HEADER_TITLE.RMU',
              headerBreadcrumb: 'HEADER_BREADCRUMB.RMU_DETAILS',
            },
          },
        ],
      },
  

      //BPS admin
      {
        path: 'dashboard-bps',
        component: BpsAdminDashboardComponent,
        canActivate: [BpsAuthGuard],
        pathMatch: 'full',
        data: { headerTitle: 'HEADER_TITLE.DASHBOARD' },
      },
      {
        path: 'data-model-customization-bps/:modelType/:id',
        canActivate: [BpsAuthGuard],
        component: DataModelCustomizationComponent,
        data: {
          configuration: DashboardConfiguration.DataModelCustomization,
          sidebarItems: [
            'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_STRUCTURE',
            'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_LINES',
            'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_DEVICES',
            'DATA_MODEL_CUSTOMIZATION.CATEGORIES.BUILDINGS_CUSTOMERS',
            'DATA_MODEL_CUSTOMIZATION.CATEGORIES.METERS',
            'DATA_MODEL_CUSTOMIZATION.CATEGORIES.SUBSTATION_TEMPLATES',
          ],
          serviceRequestSidebarItems: [
            'DATA_MODEL_CUSTOMIZATION.CUSTOMER_APPLICATION',
            'DATA_MODEL_CUSTOMIZATION.SERVICE_EXTENSION',
            'DATA_MODEL_CUSTOMIZATION.DEDICATED_SUPPLY_REQUESTS',
            'DATA_MODEL_CUSTOMIZATION.DISCONNECTION_REQUESTS',
          ],
        },
      },
      {
        path: 'utility-management',
        canActivate: [BpsAuthGuard],
        component: UtilityLayoutComponent,
        data: { headerTitle: 'HEADER_TITLE.UTILITY_MANAGEMENT' },
        children: [
          {
            path: '',
            component: UtilityListComponent,
            data: { headerTitle: 'HEADER_TITLE.UTILITY_MANAGEMENT' },
          },
          {
            path: 'add',
            component: AddUtilityComponent,
            data: {
              goBackTo: '/utility-management',
              headerTitle: 'HEADER_TITLE.UTILITY_MANAGEMENT',
              headerBreadcrumb: 'HEADER_BREADCRUMB.NEW_UTILITY',
            },
          },
          {
            path: 'details/:id',
            component: UtilityDetailsComponent,
            data: {
              goBackTo: '/utility-management',
              headerTitle: 'HEADER_TITLE.UTILITY_MANAGEMENT',
              headerBreadcrumb: 'HEADER_BREADCRUMB.UTILITY_DETAILS',
            },
          },
        ],
      },
      {
        path: 'network-structure',
        component: NetworkModelCustomizationComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
        data: { 
          headerTitle: 'HEADER_TITLE.NETWORK_STRUCTURE',
          permission: [PermissionsEnum.NetworkStructure_View],
          configuration: DashboardConfiguration.NetworkModelStructure
       },
      },
      {
        path: 'network-structure/add-equipment-and-connectivity/:id',
        canActivate: [AuthGuard],
        component: AddEquipmentAndConnectivityComponent,
        data: { 
          permission: [PermissionsEnum.NetworkStructure_View],
          configuration: DashboardConfiguration.NetworkModelStructure
       },
      },
      {
        path: 'network-entity-classes/:id',
        canActivate: [AuthGuard],
        component: NetworkEntityClassesComponent,
        data: {
          configuration: DashboardConfiguration.NetworkEntityClassInstantiation,
          headerTitle: 'HEADER_TITLE.NETWORK_ENTITY_CLASSES',
          permission: [PermissionsEnum.NetworkEntityClasses_View],
        },
      },
      {
        path: 'data-model-customization',
        redirectTo: 'data-model-customization/0',
        pathMatch: 'full',
      },
      {
        path: 'data-model-customization/:id',
        canActivate: [AuthGuard],
        component: DataModelCustomizationComponent,
        data: {
          headerTitle: 'HEADER_TITLE.DATA_MODEL_CUSTOMIZATION',
          configuration: DashboardConfiguration.DataModelCustomization,
          sidebarItems: [
            'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_STRUCTURE',
            'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_LINES',
            'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_DEVICES',
            'DATA_MODEL_CUSTOMIZATION.CATEGORIES.BUILDINGS_CUSTOMERS',
            'DATA_MODEL_CUSTOMIZATION.CATEGORIES.METERS',
            'DATA_MODEL_CUSTOMIZATION.CATEGORIES.SUBSTATION_TEMPLATES',
          ],
          permission: [PermissionsEnum.DataModelCustomization_View],
        },
      },
      {
        path: 'audit-log',
        component: AuditLogComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
        data: { headerTitle: 'HEADER_TITLE.AUDIT_LOG' },
      },
      {
        path: 'audit-trail',
        component: AuditTrailComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
        data: { headerTitle: 'HEADER_TITLE.AUDIT_TRAIL' },
      },
      {
        path: 'assets',
        component: UtilityAssetAndCustomerEntitiesComponent,
        canActivate: [BpsAuthGuard],
        pathMatch: 'full',
        data: { headerTitle: 'HEADER_TITLE.UTILITY_ASSET_CUSTOMER_ENTITIES' },
      },
      {
        path: 'job-history',
        component: BpsAdminJobHistoryComponent,
        pathMatch: 'full',
        data: { headerTitle: 'HEADER_TITLE.BACKGROUND_JOB_HISTORY' },
        canActivate: [BpsAuthGuard],
      },
      {
        path: 'overview',
        component: AiOverviewComponent,
        pathMatch: 'full',
        data: { 
          headerTitle: 'HEADER_TITLE.OVERVIEW',
          permission: [PermissionsEnum.AI_UAV_Overview],
         },
        canActivate: [AuthGuard],
      },
      {
        path: 'batch-image-import',
        component: BatchImageImportComponent,
        pathMatch: 'full',
        data: { 
          headerTitle: 'HEADER_TITLE.BATCH_IMAGE_IMPORT',
          permission: [PermissionsEnum.AI_UAV_Batch_Image_Import]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'segmentation-list',
        component: AiSegmentationListComponent,
        pathMatch: 'full',
        data: { 
          headerTitle: 'HEADER_TITLE.SEGMENTATION_LIST',
          permission: [PermissionsEnum.AI_UAV_Segmentation_List], 
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'job-monitoring',
        component: AiJobMonitoringComponent,
        pathMatch: 'full',
        data: { 
          headerTitle: 'HEADER_TITLE.JOB_MONITORING',
          permission: [PermissionsEnum.AI_UAV_Job_Monitoring],
        },
        canActivate: [AuthGuard],
      },
    ],
  },
  // Catch-all: any unmatched URL redirects to the default root route.
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
